import React, {useState, useEffect} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';
import {marked} from 'marked';

const InfoDialog = ({open, onClose}) => {
    const [markdownContent, setMarkdownContent] = useState('');

    useEffect(() => {
        const basePath = process.env.PUBLIC_URL || '';
        fetch(`${basePath}/information_text.md`)
            .then((response) => response.text())
            .then((text) => setMarkdownContent(marked(text)))
            .catch((error) => console.error('Error loading markdown file:', error));
    }, []);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                    border: '1px solid rgba(226, 232, 240, 0.6)'
                }
            }}
        >
            <DialogTitle sx={{
                background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
                color: 'white',
                textAlign: 'center',
                py: 3
            }}>
                <Typography variant="h5" sx={{fontWeight: 600}}>
                    About EndoLink
                </Typography>
            </DialogTitle>
            <DialogContent sx={{p: 4}}>
                <div
                    dangerouslySetInnerHTML={{__html: markdownContent}}
                    style={{
                        fontSize: '1rem',
                        lineHeight: '1.7',
                        color: '#374151'
                    }}
                />
            </DialogContent>
            <DialogActions sx={{p: 3, background: 'rgba(248, 250, 252, 0.5)'}}>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    sx={{
                        borderRadius: 2,
                        px: 3,
                        py: 1,
                        textTransform: 'none',
                        fontWeight: 500
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InfoDialog;